export default __webpack_public_path__ + "static/media/CenturyGothicPaneuropeanBoldItalic.87e19d18.ttf";